export default __webpack_public_path__ + "static/media/tglogov5_small.9fe99340.png";